
'use strict'

import Subscribe from "./utils/Subscribe";

class Footer{
    constructor(){
        this.main = document.getElementById('footer');
        this._subscribe = new Subscribe(this.main.querySelector('.subscribe'));
        
        this._subscriptionSticky = document.getElementById('subscription_sticky');
    }

    getElement(){
        return this.main;
    }
}

export default Footer;